// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__26BEQ","head":"Table_head__1VUwi","col":"Table_col__20UUK"};